import React from 'react';
import { StepLine, StepsContainer } from './line-steps.style';

interface LineStepsProps {
    total: number;
    current: number;
}

const LineSteps: React.FC<LineStepsProps> = ({ total, current }) => {
    return (
        <StepsContainer>
            {Array.from({ length: total }).map((_, idx) => (
                <StepLine key={`step-${idx}`} active={idx < current} />
            ))}
        </StepsContainer>
    );
};

export default LineSteps;
